import mutations from './cancelledAppointments.mutations'
import actions from './cancelledAppointments.actions'
import getters from './cancelledAppointments.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
